import useOperationListContext from "./useOperationListContext";
import { quantityColumnWidth } from "../constants";
import UnitCostInput from "./UnitCostInput";

export default function EditableCostColumns() {
  const { quantities } = useOperationListContext();

  return (
    <div className="grow flex divide-x divide-slate-100">
      {quantities.map((q) => (
        <div
          key={q}
          className="px-1 pb-1 flex flex-col justify-end items-end gap-1"
          style={{
            maxWidth: quantityColumnWidth,
            minWidth: quantityColumnWidth,
          }}
        >
          <UnitCostInput quantity={q} fieldName="total_cost" />
        </div>
      ))}
    </div>
  );
}
